import { render, staticRenderFns } from "./GalleryView.vue?vue&type=template&id=22794a81&scoped=true&"
import script from "./GalleryView.vue?vue&type=script&lang=js&"
export * from "./GalleryView.vue?vue&type=script&lang=js&"
import style0 from "./GalleryView.vue?vue&type=style&index=0&id=22794a81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22794a81",
  null
  
)

export default component.exports